import React, { FunctionComponent, ReactElement, useState, useEffect } from "react";
import { List, ListItem, ListItemText, TreeList, TreeListItem, TreeListItemProps } from "@episerver/ui-framework";

interface MenuItem {
    name: string;
    url: string;
    children: MenuItem[];
}

interface ItemNavigationProps {
    items: MenuItem[];
    selectedIndex?: number;
    aspectNavigation?: boolean;
    handleSelect?: (selectedIndex: number) => void;
}

const generateList = (
    items: MenuItem[],
    selectedIndexPath: number[] = [],
    level = 1,
    selectionPath = true
): ReactElement<TreeListItemProps>[] =>
    items.map((item, index) =>
        <TreeListItem
            key={item.url}
            label={item.name}
            tooltip={item.name}
            selected={selectionPath && level === selectedIndexPath.length && index === selectedIndexPath[level - 1]}
            expand
            {...item.url && item.url[0] === "#" ? { href: item.url } : {}}
        >
            {item.children.length > 0 ? generateList(item.children, selectedIndexPath, level + 1, index === selectedIndexPath[level - 1]) : undefined}
        </TreeListItem>
    );

export const ItemNavigation: FunctionComponent<ItemNavigationProps> = ({
    items,
    selectedIndex,
    aspectNavigation,
    handleSelect
}) => {
    const [selectedIndexPath, setSelectedIndexPath] = useState([0]);

    const navigate = (url: string): void => {
        window.location.href = url;
    };

    useEffect(() => {
        // Reset aspect navigation when we have a new set of items.
        setSelectedIndexPath([0]);
    }, [items]);

    return (
        aspectNavigation ?
            (<TreeList onSelection={indexPath => {
                setSelectedIndexPath(indexPath);
                let levelItems = items;
                for (let i = 0, len = indexPath.length; i < len; i++) {
                    const item = levelItems[indexPath[i]];
                    if (i === len - 1) {
                        navigate(item.url);
                    } else {
                        levelItems = item.children;
                    }
                }
            }}>
                {generateList(items, selectedIndexPath)}
            </TreeList>) :
            <List onAction={({ detail }) => handleSelect && handleSelect(detail.index)}>
                {items.map((item, index) => <ListItem
                    key={item.url}
                    selected={index === selectedIndex}
                    tag="a"
                    {...item.url && item.url[0] === "#" ? { href: item.url } : {}}
                >
                    <ListItemText>{item.name}</ListItemText>
                </ListItem>)}
            </List>
    );
};
